module.exports = __webpack_public_path__ + "media/images/lb/000-744380f8d791a6d0eed221211710fe5f.svg";